import { render, staticRenderFns } from "./ReadStatistics.vue?vue&type=template&id=0e90a1f5&scoped=true&"
import script from "./ReadStatistics.vue?vue&type=script&lang=js&"
export * from "./ReadStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ReadStatistics.vue?vue&type=style&index=0&id=0e90a1f5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e90a1f5",
  null
  
)

export default component.exports